import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PlannedGraph from './PlannedGraph';
import PerformanceGraph from './PerformanceGraph';

function TabContainer(props) {
  return (
    <Typography component="div" >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    
  },
});

class GraphTabs extends React.Component 
{
  state = {
    value: 0,
  };

  handleChange = (event, value) => 
  {
    this.setState({ value });
  };

  render() 
  {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
        <AppBar position="static"  style={{backgroundColor:"#00796B !important"}} color="#00796B" >
          <Tabs value={value} onChange={this.handleChange}>
            <Tab label="Planned Curve" />
            <Tab label="Performance Curve" />
          </Tabs>
        </AppBar>
        {(value === 0) && <TabContainer><PlannedGraph data={this.props.data}/></TabContainer>}
        {(value === 1) && <TabContainer><PerformanceGraph data={this.props.data}/></TabContainer>}
     
      </div>
    );
  }
}

GraphTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GraphTabs);



// WEBPACK FOOTER //
// ./src/features/daily/GraphTabs.js